import { render, staticRenderFns } from "./VideoTemplate.vue?vue&type=template&id=2ff4676d&scoped=true&"
import script from "./VideoTemplate.vue?vue&type=script&lang=js&"
export * from "./VideoTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VideoTemplate.vue?vue&type=style&index=0&id=2ff4676d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4676d",
  null
  
)

export default component.exports